import { atom } from 'jotai';

/** Logical device currently selected in the multi-merchant header select (initialized from the URL). */
export const selectedLogicalDeviceIdAtom = atom<string>('');
